// app/javascript/controllers/embed_social_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    ref: String
  }

  connect() {
    this.loadEmbedSocial()
  }

  disconnect() {
    // Clean up the widget container on disconnect
    this.element.innerHTML = ""
  }

  loadEmbedSocial() {
    const scriptId = "EmbedSocialHashtagScript"
    
    // Create the hashtag div
    this.element.innerHTML = `<div class="embedsocial-hashtag" data-ref="${this.refValue}"></div>`

    // Remove existing script to force fresh load
    const existingScript = document.getElementById(scriptId)
    if (existingScript) {
      existingScript.remove()
    }

    // Clear any existing EmbedSocial global state
    if (window.EmbedSocialHashtagScript) {
      delete window.EmbedSocialHashtagScript
    }

    // Load script fresh each time
    const script = document.createElement("script")
    script.async = true
    script.id = scriptId
    script.src = "https://embedsocial.com/cdn/ht.js"
    document.head.appendChild(script)
  }
}
